export default "__VITE_ASSET__Dw8Wj5i1__"